export default __webpack_public_path__ + "static/media/profile-cover.4b034f41.jpg";